import type {XlsxRow} from "./types.ts";
import {createRef} from "preact";
import {useState} from "preact/hooks";
import {getAtDate, throwIfInvalid} from "./utils.ts";
import {DateTime, Duration} from "luxon";

export function CompoundInterest({historic}: {
    historic: XlsxRow[]
}) {
    const P = createRef<HTMLInputElement>();
    const A = createRef<HTMLInputElement>();
    const i = createRef<HTMLInputElement>();
    const sd = createRef<HTMLInputElement>();
    const ed = createRef<HTMLInputElement>();
    const [result, setResult] = useState("");

    function calc() {
        const fi = throwIfInvalid(DateTime.fromJSDate(sd.current!.valueAsDate!));
        const ff = throwIfInvalid(DateTime.fromJSDate(ed.current!.valueAsDate!));
        if (!fi.isValid || !ff.isValid) throw new Error();
        const months = ff.diff(fi, 'months');
        const monthlyInterest = i.current!.valueAsNumber / 100 / 12.0;
        const fv = (
            P.current!.valueAsNumber * Math.pow(1 + monthlyInterest, months.months)
        ) + (
            A.current!.valueAsNumber! * ((Math.pow(1 + monthlyInterest, months.months) - 1) / monthlyInterest)
        )
        const investmentResult = `Valor de inversión tras ${months.months} meses: ${fv.toFixed(2)}$.`;
        const lastUIDate = historic[historic.length-1].date;
        let UIResult: string;
        if (ff > lastUIDate) {
            UIResult = "No puedo predecir el valor de la UI a futuro."
        } else {
            const initialUI = P.current!.valueAsNumber / getAtDate(historic, fi)!.ui;
            const cumulativeUI = Array.from(
                {length: months.months - 1}, (_x, i) => A.current!.valueAsNumber / getAtDate(historic, fi.plus(Duration.fromObject({
                    months: i + 1
                })))!.ui
            ).reduce((a, b) => a + b);
            const finalUI = initialUI + cumulativeUI;
            const finalPeso = finalUI * getAtDate(historic, ff)!.ui;
            UIResult = `Equivalente en UI: ${finalPeso.toFixed(2)}$.`;
        }
        setResult(`${investmentResult} ${UIResult}`);
    }

    return (
        <div class="pt-5 col col-12 mb-2" id="compound">
            <h1 class="text-center">Interés compuesto vs. UI</h1>
            <div class="clearfix">
                <div class="mb-3 w-50 float-start">
                    <label for="P" class="form-label">Capital
                        Inicial</label>
                    <input type="number" id="P" class="form-control"
                           ref={P}/>
                </div>
                <div class="mb-3 w-50 float-start">
                    <label for="A" class="form-label">Aporte
                        Mensual</label>
                    <input type="number" id="A" class="form-control"
                           ref={A}/>
                </div>
                <div class="mb-3 w-100 float-start">
                    <label for="i" class="form-label">Tasa de
                        Interés Anual</label>
                    <input type="number" id="i" class="form-control"
                           ref={i}/>
                </div>
                <div class="mb-3 w-100 float-start">
                    <label for="sd" class="form-label">
                        Fecha de Inicio
                    </label>
                    <input type="date" id="ed" class="form-control"
                           ref={sd}/>
                </div>
                <div class="mb-3 w-100 float-start">
                    <label for="ed" class="form-label">
                        Fecha de Finalización
                    </label>
                    <input type="date" id="ed" class="form-control"
                           ref={ed}/>
                </div>
                <button onClick={calc}
                        class="btn btn-primary w-100">Calcular
                </button>
                <p class="text-center">
                    {result}
                </p>
            </div>
        </div>
    )
}